// extracted by mini-css-extract-plugin
export default {"product":"CardProduct_product__JThCJ","product__img":"CardProduct_product__img__Okv+E","title":"CardProduct_title__2YtWn","price":"CardProduct_price__nFYRU"};